import React, { useState, useRef } from 'react';

import { WidgetProps } from './WidgetProps';
import { getDropShadowStyle } from './helper';
import { useWidgetAnimation } from './useWidgetAnimation';

const ImageWidget = ({
	id,
	isShowWidget,
	isExiting,
	onExitDone,
	itemRef,
	onClickItem,
	widgetTemplateId,
	settings,
	isSafari,
	onContextMenu,
	style,
	isClickable,
}: WidgetProps.BaseProps) => {

	const gElementRef = useRef<SVGGElement | null>();

	const [isHover, setIsHover] = useState(false);

	useWidgetAnimation({ gElementRef, style, isShowWidget, isExiting, onExitDone });

	const { imgUrl, bgImgUrl } = settings;

	const handleMouseEnter = () => {
		setIsHover(true);
	};

	const handleMouseLeave = () => {
		setIsHover(false);
	};

	const { dropShadow, hoverDropShadow } = getDropShadowStyle(style.transformSettings);

	return (
		<g id={widgetTemplateId} className={`${!isSafari ? 'widget' : ''} widget_${widgetTemplateId}`}>
			<g ref={itemRef}>
				<g
					ref={r => gElementRef.current = r}
					data-widget-id={id}
					data-template-id={widgetTemplateId}
					onMouseEnter={handleMouseEnter}
					onMouseLeave={handleMouseLeave}
					onContextMenu={(e) => {
						e.preventDefault();
						onContextMenu?.(itemRef, !!isShowWidget);
						return false;
					}}
					style={{
						filter: "drop-shadow(" + (isHover ? (hoverDropShadow || dropShadow) : dropShadow) + ")",
					}}
				>
					<foreignObject>
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								width: '100%',
								height: '100%',
							}}
						>
							<img
								className="image-widget"
								src={isHover ? (bgImgUrl || imgUrl) : imgUrl}
								style={{
									display: isShowWidget || isExiting ? 'block' : 'none',
									width: '100%',
								}}
								onClick={(e) => {
									e.stopPropagation();
									onClickItem?.(itemRef);
								}}
							/>
						</div>
					</foreignObject>
				</g>
			</g>
		</g>
	);
};

export default ImageWidget;
